import axios from "axios";
import { toast } from "react-toastify";
import { ABOUT_US_INFO_ERROR, GET_ABOUT_US_INFO } from "../types";

export const getaboutusData = (e) => async (dispatch) => {
  try {
    var data = new FormData();
    var config = {
      method: "get",
      headers: {},
      url: `${process.env.NEXT_PUBLIC_API_URL}/view-page?page=about_us`,
      data: data,
    };
    const res = await axios(config);
    if (res.data.success) {
      dispatch({
        type: GET_ABOUT_US_INFO,
        payload: res.data,
      });
    }
  } catch (error) {
    toast.error(error.response, {
      onClose: () => location.reload(),
    });
    dispatch({
      type: ABOUT_US_INFO_ERROR,
      payload: error.response,
    });
  }
};
